/* Who a thing belongs to, in colour.

Team alone was enough while every game was a 1v1 — your side's colour was your colour. In a 2v2 or
3v3 it is not: a green city might be yours or your partner's, and "is that mine?" became a question
the map could not answer (2026-08-21).

So the map paints by *relation*, never by team: **yours green, an ally's blue, an enemy's red**,
whichever side you are on (owner, 2026-09-10). It is the palette the city modal and the route
legend already used, and the one the minimap did not: there, a colour was picked by team, so a
human read the three classes correctly by accident and a zombie read them inverted — their own
cities red, the enemy humans green, and "red means them" false for half the players in the game.

The team colours below still exist, because a *team* is a different fact from a relation and some
marks are about the team: the replay's camps, whose builder has no viewer to be a relation to, and
the theme's --human / --zombie, which are the same two values written for CSS. Nothing that answers
"is that mine?" reads them. */

export const TEAM_COLORS = {
  human: "#5ce07b",
  zombie: "#e2564b",
}

export const TEAM_RGB = {
  human: [92, 224, 123],
  zombie: [226, 86, 75],
}

/* Mine, ours, theirs. Green and red are the team colours doing a second job — that is the point,
   not a coincidence: a player learns one green and one red. Blue matches --info in theme.css,
   which is what every panel tints an ally with. */
export const RELATION_COLORS = {
  self: "#5ce07b",
  ally: "#5aa9d6",
  enemy: "#e2564b",
}

export const RELATION_RGB = {
  self: [92, 224, 123],
  ally: [90, 169, 214],
  enemy: [226, 86, 75],
}

/* "self" | "ally" | "enemy" for one owner, given the viewer. Unknown teams read as enemy: on a map,
   "not proven friendly" is the safe default. */
export const relationOf = ({ ownerId, userId, teamOf }) => {
  if (String(ownerId) === String(userId)) return "self"
  const mine = teamOf(userId)
  const theirs = teamOf(ownerId)
  return mine != null && theirs != null && mine === theirs ? "ally" : "enemy"
}

export const relationColor = (relation) => RELATION_COLORS[relation] || RELATION_COLORS.enemy

export const relationRgb = (relation) => RELATION_RGB[relation] || RELATION_RGB.enemy
